import React, { useState, useEffect } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Document, Page, pdfjs } from 'react-pdf';

// Use unpkg CDN as it reliably mirrors the specific pdfjs-dist version installed
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfThumbnail = ({ url, width = 200, onClick }) => {
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(true);

    // Reset state when URL changes
    useEffect(() => {
        setError(false);
        setLoading(true);
    }, [url]);

    if (!url) return null;

    return (
        <Box sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            bgcolor: '#fff',
            cursor: onClick ? 'pointer' : 'default',
            position: 'relative',
            borderRadius: '4px',
            '&:hover': onClick ? {
                opacity: 0.95,
                transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            } : {}
        }}
            onClick={onClick}
        >
            {error ? (
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    textAlign: 'center',
                    p: 1
                }}>
                    <PictureAsPdfIcon sx={{ fontSize: 40, color: '#e53935', opacity: 0.4 }} />
                    <Typography variant="caption" sx={{ color: '#bdbdbd', fontSize: '9px', lineHeight: 1.2 }}>
                        Preview Error<br />(CORS or File missing)
                    </Typography>
                </Box>
            ) : (
                <Document
                    file={url}
                    loading={
                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
                            <CircularProgress size={20} sx={{ color: '#ff6100' }} />
                            <Typography variant="caption" sx={{ color: '#999', fontSize: '10px' }}>Loading PDF...</Typography>
                        </Box>
                    }
                    onLoadSuccess={() => setLoading(false)}
                    onLoadError={(err) => {
                        console.error('PDF Load Error:', err);
                        setError(true);
                        setLoading(false);
                    }}
                >
                    <Page
                        pageNumber={1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        width={width}
                        onRenderError={() => setError(true)}
                    />
                </Document>
            )}


        </Box>
    );
};

export default PdfThumbnail;
